
import React, { useEffect, useMemo, useState } from "react";

// Chakra imports
import {
    Box,
    Button,
    Flex,
    Grid,
    Link,
    Text,
    useColorModeValue,
    SimpleGrid,
    Tabs,
    TabList,
    TabPanels,
    Tab,
    TabPanel,
    Stack,
    Alert,
    AlertIcon,
    IconButton,
} from "@chakra-ui/react";
import { MdViewList, MdViewModule, MdCheckCircle, MdCancel, MdDelete, MdShoppingCart, MdOutlineError } from "react-icons/md";
import Loader from "../../../../components/loader/Loader"


// Custom components
import ItemWhitelist from "views/admin/suspicious/components/ItemWhitelist";
import Card from "components/card/Card.js";
import { SearchBar } from 'components/navbar/searchBar/SearchBar';
import { useListContext } from '../../../../contexts/listContext';
import NonReportableItem from "views/admin/suspicious/components/NonReportableItem";

import { useProductStore } from "../../../../store/useProductStore";
// At the top of NoneAbuseProducts.js



export default function Whitelisted(props) {
    const backendUrl = process.env.REACT_APP_BACKEND_URL;
    const {
        userId,
        suspiciousProducts,
        fetchProductsByStatus,
        abuseTypes,
        isAdmin,
        setNoAbuseProducts,
        noAbuseProducts


    } = props;
    // Chakra Color Mode
    const textColor = useColorModeValue("secondaryGray.900", "white");
    const textColorBrand = useColorModeValue("brand.500", "white");
    const [productsToShow, setProductsToShow] = useState(20); // Initial number of products to show
    const productsPerPage = 20; // Number of products to load per page
    const [showLoadMore, setShowLoadMore] = useState(true);
    const [updateSeller, setUpdateSeller] = useState([])
    const [searchedProds, setSearchedProds] = useState([]);
    const { list, checkedPlatforms, abuse_type, dateFilter, checkedAbuseTypes } = useListContext();
    const [statusUpdate, setStatusUpdate] = useState(false);
    const [sortedProducts, setSortedProducts] = useState([]);
    // const noAbuseProducts = useProductStore(state => state.products["noAbuse"] || []);
    const [abuseCulprit, setAbuseCulprit] = useState([]);
    const [isLoading, setIsLoading] = useState("")

    const { products, moveProducts, updateProducts } = useProductStore();
    const [viewMode, setViewMode] = useState("grid");
    const [searchText, setSearchText] = useState("");

    // const allNonReportableProducts = useMemo(() => {

    //     const source = products["nonReportable"] || [];
    //     console.log("source", source);
    //     return source.filter((prod, index, self) => {
    //         const productId = prod?.psm_id ?? prod?.pd_id;
    //         return productId != null && index === self.findIndex(
    //             p => (p?.psm_id ?? p?.pd_id) === productId
    //         );
    //     });
    // }, [products?.nonReportable]);

    const [successAlert, setSuccesAlert] = useState('');
    const [failureAlert, setFailureAlert] = useState('');

    const handleSuccessAlert = async (alertMessage) => {
        setSuccesAlert(alertMessage);
        setTimeout(() => {
            setSuccesAlert('');
        }, 5000);
    }
    const handleFailureAlert = async (alertMessage) => {
        setFailureAlert(alertMessage);
        setTimeout(() => {
            setFailureAlert('');
        }, 5000);
    }

    const loadMore = () => {
        setProductsToShow(productsToShow + productsPerPage);
    };
    const loadLess = () => {
        setProductsToShow(productsToShow - productsPerPage);
    };

    const handleUpdateSeller = async (product, seller_status) => {
        try {
            const existingIndex = updateSeller.findIndex(item => item.product.psm_id === product.psm_id);

            if (existingIndex !== -1) {
                // Product already exists, update its status
                setUpdateSeller(prev => {
                    const updatedSeller = [...prev];
                    updatedSeller[existingIndex].seller_status = seller_status;
                    return updatedSeller;
                });
            } else {
                // Product does not exist, add it to the list
                setUpdateSeller([...updateSeller, { product, seller_status }]);
            }
            //console.log('updateSeller', updateSeller);
        } catch (err) {
            console.error('err in handleInserSeller', err)
        }
    }

    const removeFromUpdate = async (product, seller_status) => {
        setUpdateSeller(updateSeller.filter((item) => {
            return !(item.product.psm_id === product.psm_id);
        }));
        //console.log('removed from list new Update Seller:', updateSeller);
    }

    const handleInsertAbuse = async (product, abuse_type) => {
        try {
            const existingIndex = abuseCulprit.findIndex(
                (item) => item.product.psm_id === product.psm_id
            );

            if (existingIndex !== -1) {
                setAbuseCulprit((prev) => {
                    const updated = [...prev];
                    updated[existingIndex].abuse_type = abuse_type;
                    return updated;
                });
            } else {
                setAbuseCulprit([...abuseCulprit, { product, abuse_type }]);
            }
            // console.log("abus culprit", abuseCulprit)
        } catch (err) {
            console.error("err in handleInserAbuse", err);
        }
    };

    const handleSaveChanges = async () => {
        try {
            //console.log(updateSeller);
            const uid = JSON.parse(localStorage.getItem("PAuser")).message.result.id;
            const response = await fetch(`${backendUrl}/api/sellers/updateSellerStatus/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    sellers: updateSeller,
                    uid: uid
                })
            });

            const json = await response.json();

            if (response.ok) {
                // alert("Status Updated");
                handleSuccessAlert("Changes Saved");
                // await fetchProductsByStatus('R');
                //console.log('Empty update seller', updateSeller)
            } else if (response.status === 400) {
                //console.log(json);
                // alert("Error Saving Changes");
                handleFailureAlert("Error Saving changes. Please try again ");
            }

            if (abuseCulprit.length > 0) {

                const abuseMap = new Map();

                const abused = abuseCulprit.map((item) => {
                    abuseMap.set(item.product.psm_id, item.abuse_type);

                    return {
                        psm_id: item.product.psm_id,
                        abuse_type: item.abuse_type,
                    };
                });

                const finalUpdateSeller = updateSeller.map(item => {
                    const updatedAbuse = abuseMap.get(item.product.psm_id);

                    if (!updatedAbuse) return item;

                    return {
                        ...item,
                        product: {
                            ...item.product,
                            abuse_type_id: updatedAbuse,
                        },
                    };
                });




                const abuseResponse = await fetch(
                    `${backendUrl}/api/products/reportAbuse/`,
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify({
                            products: abused,
                        }),
                    }
                );

                if (!abuseResponse.ok) {
                    setIsLoading(false)

                    handleFailureAlert("Failed to save abuse reports");
                    return;
                }


                // for (const item of updateSeller) {
                //     const { product, seller_status } = item;

                //     if (seller_status === "W") {
                //         const sellerProducts = products["suspicious"].filter(
                //             (p) => p.seller_name === product.seller_name
                //         );
                //         await moveProducts("suspicious", sellerProducts, "whitelisted");
                //     } else if (seller_status === "T") {
                //         await moveProducts("suspicious", product, "testPurchase");
                //     } else if (seller_status === "R") {
                //         await moveProducts("suspicious", product, "reported");
                //     } else if (seller_status === "X") {
                //         await moveProducts("suspicious", product, "toDelete");
                //     }
                // }

                console.log("final:", finalUpdateSeller)

                for (const item of finalUpdateSeller) {
                    const { product, seller_status } = item;

                    if (seller_status === "W") {
                        const sellerProducts = products["nonReportable"]
                            .filter(p => p.seller_name === product.seller_name)

                        await moveProducts("nonReportable", sellerProducts, "whitelisted");

                    } else if (seller_status === "T") {
                        await moveProducts("nonReportable", product, "testPurchase");

                    } else if (seller_status === "R") {
                        await moveProducts("nonReportable", product, "reported");

                    } else if (seller_status === "X") {
                        await moveProducts("nonReportable", product, "toDelete");
                    }
                }
            }
            setStatusUpdate(true)
            setAbuseCulprit([])
            setUpdateSeller([])
        } catch (e) {
            //console.log("error in handleSavechanges");
        }

        for (const item of updateSeller) {
            const { product, seller_status } = item;

            if (seller_status === "W") {
                const sellerProducts = products["nonReportable"].filter(
                    (p) => p.seller_name === product.seller_name
                );
                await moveProducts("nonReportable", sellerProducts, "whitelisted");
            } else if (seller_status === "T") {
                await moveProducts("nonReportable", product, "testPurchase");
            } else if (seller_status === "R") {
                await moveProducts("nonReportable", product, "reported");
            } else if (seller_status === "X") {
                await moveProducts("nonReportable", product, "toDelete");
            }
        }
    }

    const handleSearch = async (text) => {
        try {
            if (text) {
                setSortedProducts(products["nonReportable"].filter((item) =>
                    item.title?.toLowerCase().includes(text?.toLowerCase()) ||
                    item.keyword?.toLowerCase().includes(text?.toLowerCase()) ||
                    item.seller_name?.toLowerCase().includes(text?.toLowerCase()) ||
                    item.prod_code?.toLowerCase().includes(text?.toLowerCase())
                ));
            } else {
                setSortedProducts(products["nonReportable"]);
                handleFilter();
            }
        } catch (e) {
            console.error('error in search', e)
        }
    }
    // Add filter effect
    useEffect(() => {
        handleFilter();
        // fetchProductsByStatus("R")
    }, [list, checkedPlatforms, checkedAbuseTypes, dateFilter, products["nonReportable"]]);

    const handleFilter = async (productSource = products) => {
        try {
            let keywordId = list.map((item) => item.id);
            let platformIds = checkedPlatforms.map((item) => item.id);
            let abuseTypeId = checkedAbuseTypes;
            let allProducts = productSource["nonReportable"] || [];
            // console.log("for handleFilter ::",productSource["nonReportable"] )

            let kfilter = allProducts.filter((item) =>
                keywordId?.includes(item.keyword_id)
            );

            console.log("kfilter", kfilter)

            let pfilter = kfilter.filter((item) =>
                platformIds?.includes(item.platform_id)
            );

            let afilter = pfilter.filter((item) =>
                abuseTypeId?.includes(item.abuse_type_id) || item.abuse_type_id === null
            );

            let startDate = new Date(dateFilter.startDate);
            let endDate = new Date(dateFilter.endDate);
            endDate.setHours(23, 59, 59, 999);

            let dateSort = await afilter.filter((item) => {
                if (item.date_suspicious === undefined) {
                    item.date_suspicious = new Date().toLocaleDateString();
                }
                let date = new Date(item.date_suspicious);

                return date >= startDate && date <= endDate;
            });

            setSearchedProds(dateSort);
            setSortedProducts(dateSort);
        } catch (err) {
            console.error("error in handleFilter", err);
        }
    };


    return (
        <Box >
            {/* Main Fields */}
            {(isLoading) && <Loader />}

            <Card p='0px' w='100%' >
                <Flex justify={"space-between"} m={2}>

                    <Text px='20px' pt='10px'>Count: {sortedProducts.length}</Text>
                    <Flex gap={2}>
                        <IconButton size="md" icon={<MdViewList />} isActive={viewMode === 'list'} onClick={() => setViewMode('list')} />
                        <IconButton size="md" icon={<MdViewModule />} isActive={viewMode === 'grid'} onClick={() => setViewMode('grid')} />

                    </Flex>
                </Flex>

                <Flex
                    align={{ sm: "flex-start", lg: "center" }}
                    justify='space-between'
                    w='100%'
                    px='22px'
                    py='18px'>
                    <SearchBar m="10px" borderRadius="30px" value={searchText}
                        onChange={(e) => handleSearch(e.target.value)} />
                    {isAdmin && (

                        <Button variant='action' alignSelf='right' onClick={() => handleSaveChanges()}>Save Changes</Button>
                    )}
                </Flex>
                <SimpleGrid columns={viewMode === 'grid' ? { base: 1, md: 3, xl: 4 } : 1} spacing={3}>

                    {sortedProducts.slice(0, productsToShow).map((prod, index) => (
                        <NonReportableItem
                            key={prod.psm_id ?? prod.pd_id}
                            index={index}
                            product={prod}
                            handleInsertSeller={handleUpdateSeller}
                            removeFromInsert={removeFromUpdate}
                            statusUpdate={statusUpdate}
                            setStatusUpdate={setStatusUpdate}
                            abuseTypes={abuseTypes}
                            handleInsertAbuse={handleInsertAbuse}
                            isAdmin={isAdmin}
                            setNoAbuseProducts={setNoAbuseProducts}
                            viewMode={viewMode}
                        />
                    ))}
                </SimpleGrid>

            </Card>

            <Stack spacing={3} position='fixed' right='10px' bottom='2vh'>
                {successAlert !== '' &&
                    <Alert status='success' variant='left-accent' w='40vw'  >
                        <AlertIcon />
                        {successAlert}

                    </Alert>
                }
                {failureAlert !== '' &&
                    <Alert status='error' variant='left-accent' w='40vw'>
                        <AlertIcon />
                        {failureAlert}
                    </Alert>
                }
            </Stack>

            <Link ><Text color={textColor} fontSize='l' fontWeight='500' onClick={() => loadLess()} r='0' position='absolute' right={{ base: '10%', md: '15%', sm: '30%' }} textDecoration='underline'>
                Show less...
            </Text></Link>
            <Link ><Text color={textColor} fontSize='l' fontWeight='500' onClick={() => loadMore()} r='0' position='absolute' right={{ base: '2%', md: '5%' }} textDecoration='underline'>
                Show more...
            </Text></Link>
            {/* Delete Product */}
        </Box>
    );
}
